import styled, { css } from 'styled-components';
import { isMobileOnly } from 'react-device-detect';

const GridTemplateColumns = css`
  grid-template-columns: 25px 25px 25px minmax(100px, 400px) minmax(80px, 200px) minmax(50px, 1fr) minmax(80px, 1fr) 32px;
`;

const BasketHeader = styled.div`
  display: ${isMobileOnly ? 'flex' : 'grid'};
  flex-direction: ${isMobileOnly ? 'column' : 'unset'};
  align-items: center;
  padding: ${isMobileOnly ? '10px 70px 10px 20px' : '10px 30px 10px 20px'};
  ${GridTemplateColumns}
`;

const BasketItem = styled.div<{ isFavourite?: boolean, isChecked?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${({ isFavourite }) => (isFavourite ? 'white' : 'white')};
  border-radius: 6px;
  padding: 10px;
  overflow: hidden;
  box-shadow: ${({ isChecked }) => (isChecked ? '0 0 0px 2.5px rgba(0, 0, 128, 0.6)' : 'rgba(0, 0, 0, 0.1) 0 1px 4px 0px')};
  margin-top: 3px;
  ${GridTemplateColumns}
`;

export const Styled = {
  BasketItem,
  BasketHeader,
};
